<template>
  <el-dialog
    :visible="dialogVisible"
    width="700px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <public-table
      v-loading="Loading"
      :column="column"
      :tableData="datas"
      :addPerm="'User.Market.Application.Version.Create'"
    >
      <template v-slot:size="{ row }">
        <span>
          {{ util.unit(row.size) }}
        </span>
      </template>
      <template v-slot:status="{ row }">
        <span
          :style="{
            color: handleStateColorMap(row.status)
          }"
        >
          {{ handleStateMap(row.status) }}
        </span>
      </template>
      <template v-slot:operation="{ row }">
        <el-button
          size="mini"
          type="text"
          v-if="row.downloadURL"
          :loading="btnLoading"
          @click="fetchDownloadToken(row.downloadURL)"
        >
          下载
        </el-button>
        <el-button
          size="mini"
          type="text"
          v-if="row.status === 'empty' || row.canRegenerate"
          @click="handleGenerateOfflinePackage(row)"
        >
          {{ row.status === 'empty' ? '生成' : '重新生成' }}
        </el-button>
        <el-button
          v-if="row.status === 'failed' || row.status === 'success'"
          size="mini"
          type="text"
          @click="deleteOfflinePackage(row)"
        >
          删除
        </el-button>
      </template>
    </public-table>
  </el-dialog>
</template>
<script>
import {
  getDownloadToken,
  getOfflinePackage,
  delOfflinePackage,
  generateOfflinePackage
} from '@/api/app';
import { errorHandle } from '@/utils/error';
import util from '@/utils/source-unit';
// import { getToken } from '@/utils/auth';
// import axios from 'axios';

export default {
  name: 'OfflinePackageTemplate',
  props: {
    appID: String,
    marketID: String,
    version: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    return {
      btnLoading: false,
      util,
      timer: null, // 定时器名称
      title: '离线包',
      Loading: true,
      datas: [],
      stateMap: {
        notgenerated: '未生成',
        generating: '生成中',
        failure: '失败',
        success: '成功'
      },
      column: [
        {
          prop: 'packageType',
          label: '类型'
        },
        {
          prop: 'size',
          label: '大小',
          scopeStatus: true
        },
        {
          prop: 'status',
          label: '状态',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.fetchOfflinePackage();
  },
  methods: {
    fetchDownloadToken(downloadPath) {
      this.btnLoading = true;
      getDownloadToken()
        .then((res) => {
          this.btnLoading = false;
          if (res && res.token) {
            this.download(`${downloadPath}?token=${res.token}`);
          }
        })
        .catch((err) => {
          errorHandle(err);
          this.btnLoading = false;
        });
    },
    download(downloadPath) {
      let aEle = document.querySelector('#down-a-element');
      if (!aEle) {
        aEle = document.createElement('a');
        aEle.setAttribute('download', 'filename');
        document.body.appendChild(aEle);
      }
      aEle.href = downloadPath;
      if (document.all) {
        aEle.click();
      } else {
        const e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        aEle.dispatchEvent(e);
      }
    },
    handleGenerateOfflinePackage(info) {
      generateOfflinePackage({
        marketID: this.marketID,
        appID: this.appID,
        version: this.version,
        packageType: info.packageType
      })
        .then((res) => {
          this.fetchOfflinePackage();
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    handleStateMap(state) {
      const map = {
        empty: '未生成',
        started: '开始生成',
        generating: '生成中',
        failed: '失败',
        success: '成功'
      };
      return map[state];
    },
    handleStateColorMap(state) {
      const map = {
        empty: '#314659',
        started: '#faad14',
        generating: '#05a',
        failed: '#f5222d',
        success: '#67C23A'
      };
      return map[state];
    },
    fetchOfflinePackage() {
      getOfflinePackage({
        marketID: this.marketID,
        appID: this.appID,
        version: this.version
      })
        .then((res) => {
          this.Loading = false;
          this.datas = res;
          if (res && res.length > 0) {
            let isGenerate = false;
            res.map((item) => {
              if (
                item.status !== 'empty' &&
                item.status !== 'success' &&
                item.status !== 'failed'
              ) {
                isGenerate = true;
              }
            });
            if (isGenerate) {
              this.timer = setTimeout(this.fetchOfflinePackage, 5000);
            }
          }
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    beforeDestroy() {
      clearTimeout(this.timer);
      this.timer = null;
    },
    close() {
      this.onClose && this.onClose();
    },
    deleteOfflinePackage(row) {
      this.$confirm('是否要删除该应用离线包?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handledeleteOfflinePackage(row);
      });
    },
    handledeleteOfflinePackage(info) {
      delOfflinePackage({
        marketID: this.marketID,
        appID: this.appID,
        version: this.version,
        packageType: info.packageType
      })
        .then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.fetchOfflinePackage();
        })
        .catch((err) => {
          errorHandle(err);
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.CodeMirror-line {
  line-height: 20px !important;
}
::v-deep .el-form-item__content {
  line-height: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/offlinePackageTemplate.vue